import { useMemo } from 'react';
import {
  ADMIN_LINE_REQUESTS,
  GOOGLE_RCS,
  INTERAGENCY_CHAT,
  TF911,
  TT911,
} from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import { SESSION_TYPES } from '../constants';

function useAvailableSessionTypes() {
  const hasTF911 = useHasCapability(TF911).hasCapability;
  const hasRCS = useHasCapability(GOOGLE_RCS).hasCapability;
  const hasAdminLine = useHasCapability(ADMIN_LINE_REQUESTS).hasCapability;
  const hasTT911 = useHasCapability(TT911).hasCapability;
  const hasInteragency = useHasCapability(INTERAGENCY_CHAT).hasCapability;

  return useMemo(() => {
    const enabled = {
      sms: !!hasTF911,
      rcs: !!hasRCS,
      sms_admin: !!hasAdminLine,
      tcapi: !!hasTT911,
      interagency: !!hasInteragency,
    } as const;

    return SESSION_TYPES.filter(
      ({ value }) => enabled[value as keyof typeof enabled] ?? true,
    );
  }, [hasTF911, hasRCS, hasAdminLine, hasTT911, hasInteragency]);
}

export default useAvailableSessionTypes;
